import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbBallpen, TbCertificate } from "react-icons/tb";
import { MdMarkEmailRead } from "react-icons/md";
import { useDispatch } from "react-redux";
import Label from "../../component/Label";
import Toaster from "../../component/Toaster";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";

export default function Certificate() {
  const { t } = useTranslation();
  const [certificateData, setCertificateData] = useState<any>({});
  const dispatch = useDispatch<any>();
  const getCertificateInfo = () => {
    dispatch(dashboardAction({ apiAction: "getCertificateInfo" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setCertificateData(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  useEffect(() => {
    getCertificateInfo();
  }, []);

  return (
    <div className=" padding-left-10 margin-right-10">
      <div className=" dashboard-heading padding-y-10 ">
        <div className="font-14 bolder">{t("certificateInfo")}</div>
      </div>
      <Grid className=" flex-wrap justify-center">
        <Grid className="certificate-box1" item xs={6} md={3.5}>
          <div>
            <div className="certificate-icon">
              <TbCertificate />
            </div>
            <div className="certificate-title">
              <Label title={t("requisition")} />
            </div>
            <div className="whitebox">{certificateData?.Requisition || 0}</div>
          </div>
        </Grid>
        <Grid className="certificate-box2" item xs={6} md={3.5}>
          <div>
            <div className="certificate-icon">
              <MdMarkEmailRead />
            </div>
            <div className="certificate-title">
              <Label title={t("partialRequisition")} />
            </div>
            <div className="whitebox">
              {certificateData?.["Partial Requisition"] || 0}
            </div>
          </div>
        </Grid>
        <Grid className="certificate-box3" item xs={6} md={3.5}>
          <div>
            <div className="certificate-icon certificate-icon3">
              <TbBallpen />
            </div>
            <div className="certificate-title">
              <Label title={t("dispatchPending")} />
            </div>
            <div className="whitebox">{certificateData?.Approved || 0}</div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
